document.addEventListener('DOMContentLoaded', function () {
  // Find all UGC sections on the page
  const ugcSections = document.querySelectorAll('.section-ugc');

  if (ugcSections.length === 0) return;

  // Process each UGC section
  ugcSections.forEach(function (section) {
    const videos = section.querySelectorAll('.ugc-video');
    if (videos.length === 0) return;

    // Function to mute all videos in this section
    function muteAllVideos() {
      videos.forEach((video) => {
        video.muted = true;
        // Update data attribute on the ugc container
        const ugcContainer = video.closest('.ugc-container');
        if (ugcContainer) {
          ugcContainer.setAttribute('data-muted', 'true');
        }
      });
    }

    // Function to handle video click - mute all videos, then unmute clicked video if it was muted
    function handleVideoClick(clickedVideo) {
      // Capture the mute state of the clicked video before muting all videos
      const wasClickedVideoMuted = clickedVideo.muted;
      
      // First, mute all videos
      videos.forEach((video) => {
        video.muted = true;
        const ugcContainer = video.closest('.ugc-container');
        if (ugcContainer) {
          ugcContainer.setAttribute('data-muted', 'true');
        }
      });
      
      // If the clicked video was muted before, unmute it
      if (wasClickedVideoMuted) {
        clickedVideo.muted = false;
        const clickedUgcContainer = clickedVideo.closest('.ugc-container');
        if (clickedUgcContainer) {
          clickedUgcContainer.setAttribute('data-muted', 'false');
        }
      }
    }

    // Add event listeners to each video
    videos.forEach((video, index) => {
      // Handle user click/interaction - mute all videos, then unmute clicked video if it was muted
      video.addEventListener('click', function () {
        handleVideoClick(video);
      });

      // Handle timeupdate event to track playback progress
      video.addEventListener('timeupdate', function () {
        const ugcContainer = video.closest('.ugc-container');
        if (ugcContainer && !video.paused) {
          const progress = (video.currentTime / video.duration) * 100;
          ugcContainer.style.setProperty('--video-progress', `${progress}%`);
          ugcContainer.setAttribute('data-playing', 'true');
        }
      });

      // Handle pause event to stop progress updates
      video.addEventListener('pause', function () {
        const ugcContainer = video.closest('.ugc-container');
        if (ugcContainer) {
          ugcContainer.style.setProperty('--video-progress', '0%');
          ugcContainer.removeAttribute('data-playing');
        }
      });

      // Handle play event to set playing attribute
      video.addEventListener('play', function () {
        const ugcContainer = video.closest('.ugc-container');
        if (ugcContainer) {
          ugcContainer.setAttribute('data-playing', 'true');
        }
      });

    });

    // Create intersection observer for this section
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            // Section is out of view - mute all videos
            muteAllVideos();
          } else {
            // Section is in view - ensure all videos remain muted until user clicks
            // This prevents any accidental unmuting when section comes into view
            muteAllVideos();
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the section is visible
        rootMargin: '0px 0px -10% 0px', // Add some margin to trigger slightly before the section is fully out of view
      }
    );

    // Start observing this section
    observer.observe(section);

    // Initialize all videos as muted and start playing them
    videos.forEach((video) => {
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      
      // Set data attribute on the ugc container
      const ugcContainer = video.closest('.ugc-container');
      if (ugcContainer) {
        ugcContainer.setAttribute('data-muted', 'true');
      }
      
      // Ensure video loads and plays
      video.load();
      video.play().catch(error => {
        // Try again after a short delay
        setTimeout(() => {
          video.play()
        }, 100);
      });
    });
  });
});